import Generator from '../../../../Generator'
import Types from '../../../../../actions/Types'

export default Generator.node({
  baseType: Types.PRODUCTS,
  nodeType: Generator.NODETYPE.GET,
  suffixType: 'FULL'
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/products/get/full.js